export const INITIAL_REGION = {
  latitude: -37.78825,
  longitude: -122.4324,
  latitudeDelta: 0.0922,
  longitudeDelta: 0.0421,
};

export const LATITUDE_DELTA = 0.01;
export const LONGITUDE_DELTA = 0.01;

export const IMAGE_OPTIONS = {
  width: 300,
  height: 400,
  cropping: false,
  includeBase64: true,
  compressImageQuality: 0.8,
  maxWidth: 1200,
  maxHeight: 1600,
  includeExif: true,
};
